import eq from "lodash-es/eq"

import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { EAvatarFallbackVariant } from "./avatar.types"

const styles = {
    component: {
        container: (): string => "relative",
        img: (): string => "rounded-full",
        avatar: (): string =>
            buildCssClassName("[cursor:pointer] [object-fit:cover]", getTransitionTwClasses("[width]", 200)),
        constructedAvatar: ({ variant }: { variant: EAvatarFallbackVariant }): string =>
            buildCssClassName(
                "rounded-full",
                "flex",
                "items-center",
                "justify-center",
                "box-content",
                "border-[1px]",
                eq(variant, EAvatarFallbackVariant.DarkBlueImage) && "bg-blue-200 border-white",
                eq(variant, EAvatarFallbackVariant.BlueColored) && "bg-blue-500 border-blue-400",
                eq(variant, EAvatarFallbackVariant.GrayColored) && "bg-gray-500 border-white",
                getTransitionTwClasses("all", 200)
            )
    },
    list: {
        container: (): string => "flex items-center",
        item: ({ withLeftMarginOffset }: { withLeftMarginOffset: boolean }): string =>
            buildCssClassName("first:ml-0", withLeftMarginOffset || "ml-[-15px]")
    }
}

export { styles as avatarStyles }
